import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

import { useLogin } from "@/api/client/auth";
import PrimaryBtn from "@/components/actions/button/primaryBtn";
import { RoboDocIcon } from "@/components/data-display/icon";
import AuthInputField from "@/components/data-input/authInput";
import { successToast } from "@/components/feedback/toast";
import { fbEvents, sendFPixelEvent } from "@/lib/fpixel";
import { phoneSchema } from "@/schema/formSchema";

function SignIn({ redirectToOtp, previousNumber }) {
  useEffect(() => {
    if (previousNumber) {
      setValue("phone", previousNumber);
    }
  }, [previousNumber]);

  const { isLoading: isLoginLoading, mutate: login } = useLogin({
    onSuccess: (loginData) => {
      redirectToOtp(loginData.data);
      successToast({ message: loginData.message });
      sendFPixelEvent(fbEvents.completeRegistration);
    },
    onError: (loginError) => {
      setError("phone", {
        type: "api-error",
        message: loginError.errors[0]?.message,
      });
    },
  });

  const {
    register,
    handleSubmit,
    setError,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
    resolver: yupResolver(phoneSchema),
  });

  const handleLogin = (userInput) => {
    login({ phone: userInput.phone });
  };

  return (
    <form className="w-full" onSubmit={handleSubmit(handleLogin)}>
      <RoboDocIcon />
      <h1 className="mb-[2.25rem] mt-[2.188rem] text-[1.25rem] font-semibold tracking-[0.14px] text-grayDisplay-700 md:mb-[2.75rem] md:text-[1.75rem]">
        Welcome! Please Sign In
      </h1>
      <AuthInputField
        isFieldRequired
        register={register}
        error={errors.phone}
        name="phone"
        type="number"
        className="w-full sm:max-w-[30rem]"
      />
      <PrimaryBtn
        btnText="Sign In"
        isLoading={isLoginLoading}
        className="mt-[1.875rem] h-[3.5rem] w-full sm:max-w-[30rem]"
      />
    </form>
  );
}

export default SignIn;
